export default {"src":"/_next/static/media/close.8ef770d2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};